import { IconButton, Modal } from "src/Components";
import { ReactComponent as PauseIcon } from "../../Assets/Cup-modal.svg";
import { IModalProps } from "..";
import "../ReturnPauseConfirmModal/ReturnPauseConfirmModal.scss";

const ReturnBreakFromCallingModal: React.FC<IModalProps> = ({ isOpen, onClose, onAction }) => (
	<Modal
		isOpen={isOpen}
		title="Уйти на перерыв"
		onClose={onClose}
		className="return-pause-confirm-modal"
		renderIcon={<PauseIcon />}
		renderFooter={(
			<>
				<IconButton outline onClick={onClose}>Продолжить работу</IconButton>
				<IconButton color="green" onClick={() => onAction("return-break-from-calling-confirm", "")}>
					Уйти на перерыв
				</IconButton>
			</>
		)}
	>
		Вызов посетителя будет отменён. Перейти на перерыв?
	</Modal>
);

export default ReturnBreakFromCallingModal;
